
<!--<div style="margin:10%">
    <button  md-raised-button  color="accent"  routerLink="/pulse/doctor">Doctor List</button>
</div>-->
<app-pulsemenu></app-pulsemenu>



<div class="body">
      <!--  <div class="bg1 pulse w-clearfix"><a href="index.html" class="logo w-inline-block"></a>



          <div class="div-block" style="    margin-top: 315px;">
            <div class="w-row">
              <div class="column-3 w-col w-col-1 w-col-small-1 w-col-tiny-1"></div>
              <div class="column w-col w-col-9 w-col-small-9 w-col-tiny-9">
                <p class="paragraph _1">PETCART is the best pet services platform for your pets to let themselffree. We handle all pet needs from gromming to health care </p>
              </div>
              <div class="column-2 w-col w-col-2 w-col-small-2 w-col-tiny-2"><img src="\assets\images\pulse.gif" width="70" class="image-29"></div>
            </div>
          </div>
        </div>-->

        <ngb-carousel class="hidden-sm-down" style="width:100% !important; margin: 15px 0px 0px 0px; box-shadow: 0px 0px;">
          <ng-template ngbSlide>
              <img class="slidepc" src="https://petcart.in/webassets/sliders/pulseslide1.jpg">

          </ng-template>
          <ng-template ngbSlide>
            <img class="slidepc" src="https://petcart.in/webassets/sliders/pulseslide2.jpg">

          </ng-template>
          <ng-template ngbSlide>
            <img class="slidepc" src="https://petcart.in/webassets/sliders/pulseslide3.jpg">

          </ng-template>
          <ng-template ngbSlide>
              <img class="slidepc" src="https://petcart.in/webassets/sliders/pulseslide4.jpg">

            </ng-template>

        </ngb-carousel>



        <ngb-carousel class="hidden-md-up" style="width:100% !important; margin-left: 0px !important; margin-bottom: 10px; box-shadow: 0px 0px;">
          <ng-template ngbSlide>
            <img class="slidepc" src="https://petcart.in/mobassets/sliders/pulseslide1.jpg">

          </ng-template>
          <ng-template ngbSlide>
            <img class="slidepc" src="https://petcart.in/mobassets/sliders/pulseslide2.jpg">

          </ng-template>

          <ng-template ngbSlide>
            <img class="slidepc" src="https://petcart.in/mobassets/sliders/pulseslide3.jpg">

          </ng-template>

        </ngb-carousel>



        <div class="bg2">
          <div class="div-block-6">
            <div>
              <div class="w-row">
              <div class="column-22 w-col w-col-2a w-col-small-4 w-col-tiny-12">
                <div class="blocks pulse" routerLink="/pulse/doctor"><img src="\assets\images\Group-8.png">
                  <h3 class="heading-block pulse">Appointment with a Vet</h3>
                </div>
              </div>
              <div class="column-21 w-col w-col-2a w-col-small-4 w-col-tiny-12">
                <div class="blocks pulse" routerLink="/pulse/onlinedoctors"><img src="\assets\images\icons8-cat-50.png">
                  <h3 class="heading-block pulse">Chat with a Vet</h3>
                </div>
              </div>


              <div class="column-19 w-col w-col-2a w-col-small-4 w-col-tiny-12" (click)="setReminder()">
                <div class="blocks pulse"><img src="\assets\images\icons8-treatment-50.png">
                  <h3 class="heading-block pulse">Set Reminders</h3>
                </div>
              </div>
              <div class="column-17 w-col w-col-2a w-col-small-4 w-col-tiny-12">
                <div class="blocks pulse" routerLink="/manageprofile/manageyourpet"><img style="    height: 50px;" src="\assets\images\icons8-hospital-3-50.png" class="image-7">
                  <h3 class="heading-block pulse">Scan Records</h3>
                </div>
              </div>
              <div class="column-20 w-col w-col-2a w-col-small-4 w-col-tiny-12">
                <div class="blocks pulse"><img src="\assets\images\icons8-pill-50.png">
                  <h3 class="heading-block pulse">Know Yourself</h3>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="div-block-20" style="    padding: 0px 50px 0 50px;    margin-top: 40px; margin-bottom: 25px;">
            <h1 class="heading-6" style="margin-bottom:10px;">About Pulse</h1>
            <span class="text-block.pulse" style="font-size: 15px !important;">Does your heart skip a beat when your pet shows signs of illness? Do you yourself get worried sick when your pet is unwell? You don’t have to worry anymore. Pulse is PETCART’s pet project and the first-of-its-kind tech platform for pet care. Pulse is your one-stop destination for booking appointments with vets, follow-ups, storing records, vaccination reminders, expert advice and lot more. We also facilitate real time interaction (text / video) with available Veterinarians to keep our furry friends happy and healthy at all times.</span>
          </div>
          <div class="container-6 w-container2 hidden-md-down">
            <div class="slider w-slider" style="overflow: visible;">
              <div class="mask w-slider-mask">
                <div class="slide w-slide" routerLink="/pulse/doctor">
                  <div class="div-block-22 pulse"><img src="\assets\images\Group-8.png" style="height: 70px; margin-top: 5px;"></div>
                  <h3 class="heading-8">Appointment with a Vet</h3>
                  <div class="text-block pulse">No worries of standing in Q . Book appointment with your vet as per your convinience .
new to your area ? Put your location to see the list of vets in your area. Choose your vet and book appointment instantly</div><a  class="button-4 w-button">Book Now</a></div>
                <div class="slide w-slide" routerLink="/pulse/onlinedoctors">
                  <div class="div-block-21 pulse"><img src="\assets\images\icons8-cat-50.png" style="height: 70px; margin-top: 5px;"></div>
                  <h3 class="heading-8">Chat with a Vet</h3>
                  <div class="text-block pulse">want to get quick advice for your furries ?cant take your pet to hospital now ?
chat with available vets with our vioce and video platforms and get a feddback and prescription from verified vets
voice
video</div><a  class="button-4 w-button">Book Now</a></div>
                <div class="slide w-slide" (click)="setReminder()">
                  <div class="div-block-22 pulse"><img src="\assets\images\icons8-treatment-50.png" style="height: 70px; margin-top: 5px;"></div>
                  <h3 class="heading-8">Set Reminders</h3>
                  <div class="text-block pulse">Missed going to vet for vaccination last time in time ? Don’t worry .Set vaccination schedules here  and keep enjoying with your furries .
want to know vaccination cycle for your new puppy/kitten . Search here and set reminders</div><a class="button-4 w-button">Set Now</a></div>
                <div class="slide w-slide" routerLink="/manageprofile/manageyourpet">
                  <div class="div-block-23 pulse"><img src="\assets\images\icons8-hospital-3-50.png" style="height: 70px; margin-top: 5px;"></div>
                  <h3 class="heading-8">Scan Records</h3>
                  <div class="text-block pulse">Missed your pet  record book last time ? Changed your city and didn’t know what was the prescription given by that vet ?
now relax and update all your pet records digitally here and get it back with a click of button</div><a  class="button-4 w-button">Upload Now</a></div>
                <div class="slide w-slide">
                  <div class="div-block-22 pulse"><img src="\assets\images\icons8-pill-50.png" style="height: 70px; margin-top: 5px;"></div>
                  <h3 class="heading-8">Know Yourself</h3>
                  <div class="text-block pulse">Seeing your furr baby gaining weight ? Want to know whats ideal for him/her ?
put his/her breed/weight and few other details to get on hand output with our indexing</div><a  class="button-4 w-button">Know Now</a></div>

              </div>
              <div class="w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-arrow-left">
                <div class="w-icon-slider-left"></div>
              </div>
              <div class="w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-arrow-right">
                <div class="w-icon-slider-right"></div>
              </div>
              <div class="slide-nav w-slider-nav w-slider-nav-invert w-round"></div>
            </div>
          </div>


        </div>
        <div class="div-block-24">
          <div class="row-5 w-row">
            <div class="column-11 w-col w-col-5 w-col-small-small-stack w-col-tiny-tiny-stack"><img src="\assets\images\food-for-thought.png" srcset="\assets\images\food-for-thought-p-500.png 500w, \assets\images\food-for-thought.png 661w" sizes="(max-width: 767px) 100vw, 42vw"></div>
            <div class="column-12 w-col w-col-7 w-col-small-small-stack w-col-tiny-tiny-stack">
              <div class="text-block-2"></div>
              <h1 class="heading-9">Food For Thought</h1>
              <p class="paragraph-3" style="text-align: left; color:#9b7544;
    padding-left: 40px;padding-top: 20px;
    padding-right: 40px;">Does your furry showing signs of pain? <br>Want to know quickly about the same before rushing to a vet!<br>
This section covers basic knowledge about health of pet. <br>This is only for basic information and in case of emrgency consult your vet to get the feedback.
</p>
              <div class="text-block-3"></div><a class="read" style="border: 2px solid #9b7544;
    padding: 15px;">Coming Soon</a></div>
          </div>
          <div>
            <div class="container-7 w-container">
              <h1 class="heading-10">Pulse Corner</h1>
              <div class="row-6 w-row">
                <div class="column-15 w-col w-col-3 w-col-small-3 w-col-tiny-6">
                  <div class="div-block-28"><img src="\assets\images\advice.png"></div>
                  <h4 class="heading-11">{{doclength}}</h4>
                  <div class="text-block-4">Vets Registered</div>
                </div>

                <div class="column-14 w-col w-col-3 w-col-small-3 w-col-tiny-6">
                  <div class="div-block-27"><img src="\assets\images\restaurant.png"></div>
                  <h4 class="heading-11">{{onlinelength}}</h4>
                  <div class="text-block-4">Online Vets</div>
                </div>

                <div class="column-13 w-col w-col-3 w-col-small-3 w-col-tiny-6">
                  <div class="div-block-26"><img src="\assets\images\route.png"></div>
                  <h4 class="heading-11">{{applength}}</h4>
                  <div class="text-block-4">Appointments</div>
                </div>


                <div class="column-16 w-col w-col-3 w-col-small-3 w-col-tiny-6">
                  <div class="div-block-29"><img src="\assets\images\chat1.png"></div>
                  <h4 class="heading-11">{{chatlength}}</h4>
                  <div class="text-block-4">Chats</div>
                </div>
              </div>
              <div class="div-block-30"></div>
            </div>
            <div class="div-block-31">
              <h1 class="heading-12">Discover Latest Articles</h1>

              <div>
                <div *ngIf="blog" data-delay="4000" data-animation="slide" data-autoplay="1" data-duration="500" data-infinite="1" class="slider-2 w-slider">
                  <div class="mask-2 w-slider-mask" >
                    <div (click)="goToBlogDetail(item.id, item.url)" class="slide-3 w-slide"*ngFor="let item of blog" style="    overflow: hidden;">
                      <img height="200px" src="https://passport.petcart.in/images/blogimage/{{item.blogcoverimg}}">
                      <div class="div-block-44" style="    margin-top: -25px;">
                        <div class="text-block-5">{{item.category}}</div>
                        <h1 class="heading-14">{{item.title}}</h1>
                        <p class="paragraph-5">{{item.body}}</p>
                      </div>
                      <div class="div-block-33 w-clearfix"><a class="link-2">Read More   &gt;&gt;</a></div>
                      <div class="div-block-34"></div>
                    </div>
                   </div>
                  <div class="w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-arrow-left">
                    <div class="w-icon-slider-left"></div>
                  </div>
                  <div class="w-hidden-main w-hidden-medium w-hidden-small w-hidden-tiny w-slider-arrow-right">
                    <div class="w-icon-slider-right"></div>
                  </div>
                  <div class="slide-nav-2 w-hidden-main w-hidden-medium w-slider-nav w-slider-nav-invert w-round"></div>
                </div>
              </div>
              <div class="div-block-30"></div>
            </div>
          </div>
        </div>
      
          </div>
